import { getApiBase } from "./apiBase";
import { getToken } from "./auth";

function headers() {
  const h = { accept: "application/json" };
  const t = getToken();
  if (t) h.authorization = `Bearer ${t}`;
  return h;
}

export async function apiGet(path, { signal } = {}) {
  const base = getApiBase().replace(/\/+$/, "");
  const url = `${base}${path.startsWith("/") ? "" : "/"}${path}`;
  const resp = await fetch(url, { signal, headers: headers() });
  const text = await resp.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    // keep raw
  }
  if (!resp.ok) {
    const msg =
      (data && (data.error || data.message)) ||
      `HTTP ${resp.status} when calling ${path}`;
    const err = new Error(msg);
    err.status = resp.status;
    err.data = data ?? text;
    throw err;
  }
  return data;
}

export async function apiGetBlob(path, { signal } = {}) {
  const base = getApiBase().replace(/\/+$/, "");
  const url = `${base}${path.startsWith("/") ? "" : "/"}${path}`;
  const t = getToken();
  const h = {};
  if (t) h.authorization = `Bearer ${t}`;
  const resp = await fetch(url, { signal, headers: h });
  if (!resp.ok) {
    let data = null;
    try {
      data = await resp.json();
    } catch {
      // ignore
    }
    const msg =
      (data && (data.error || data.message)) ||
      `HTTP ${resp.status} when calling ${path}`;
    const err = new Error(msg);
    err.status = resp.status;
    err.data = data;
    throw err;
  }
  return await resp.blob();
}

export async function apiPost(path, body, { signal } = {}) {
  const base = getApiBase().replace(/\/+$/, "");
  const url = `${base}${path.startsWith("/") ? "" : "/"}${path}`;
  const h = { ...headers(), "Content-Type": "application/json" };
  const resp = await fetch(url, { method: "POST", signal, headers: h, body: JSON.stringify(body ?? {}) });
  const text = await resp.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    // keep raw
  }
  if (!resp.ok) {
    const msg =
      (data && (data.error || data.message)) ||
      `HTTP ${resp.status} when calling ${path}`;
    const err = new Error(msg);
    err.status = resp.status;
    err.data = data ?? text;
    throw err;
  }
  return data;
}

export async function apiPut(path, body, { signal } = {}) {
  const base = getApiBase().replace(/\/+$/, "");
  const url = `${base}${path.startsWith("/") ? "" : "/"}${path}`;
  const h = { ...headers(), "Content-Type": "application/json" };
  const resp = await fetch(url, { method: "PUT", signal, headers: h, body: JSON.stringify(body ?? {}) });
  const text = await resp.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    // keep raw
  }
  if (!resp.ok) {
    const msg =
      (data && (data.error || data.message)) ||
      `HTTP ${resp.status} when calling ${path}`;
    const err = new Error(msg);
    err.status = resp.status;
    err.data = data ?? text;
    throw err;
  }
  return data;
}

export async function apiPatch(path, body, { signal } = {}) {
  const base = getApiBase().replace(/\/+$/, "");
  const url = `${base}${path.startsWith("/") ? "" : "/"}${path}`;
  const h = { ...headers(), "Content-Type": "application/json" };
  const resp = await fetch(url, { method: "PATCH", signal, headers: h, body: JSON.stringify(body ?? {}) });
  const text = await resp.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    // keep raw
  }
  if (!resp.ok) {
    const msg =
      (data && (data.error || data.message)) ||
      `HTTP ${resp.status} when calling ${path}`;
    const err = new Error(msg);
    err.status = resp.status;
    err.data = data ?? text;
    throw err;
  }
  return data;
}

// Upload a raw file (e.g. a fragment mp3) with a binary body. Default PUT.
export async function apiUpload(path, file, { method = "PUT", signal } = {}) {
  const base = getApiBase().replace(/\/+$/, "");
  const url = `${base}${path.startsWith("/") ? "" : "/"}${path}`;
  const t = getToken();
  const h = { "Content-Type": file.type || "audio/mpeg" };
  if (t) h.authorization = `Bearer ${t}`;
  const resp = await fetch(url, { method, signal, headers: h, body: file });
  const text = await resp.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    // keep raw
  }
  if (!resp.ok) {
    const msg =
      (data && (data.error || data.message)) ||
      `HTTP ${resp.status} when calling ${path}`;
    const err = new Error(msg);
    err.status = resp.status;
    err.data = data ?? text;
    throw err;
  }
  return data;
}

export async function apiDelete(path, { signal } = {}) {
  const base = getApiBase().replace(/\/+$/, "");
  const url = `${base}${path.startsWith("/") ? "" : "/"}${path}`;
  const resp = await fetch(url, { method: "DELETE", signal, headers: headers() });
  const text = await resp.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    // keep raw
  }
  if (!resp.ok) {
    const msg =
      (data && (data.error || data.message)) ||
      `HTTP ${resp.status} when calling ${path}`;
    const err = new Error(msg);
    err.status = resp.status;
    err.data = data ?? text;
    throw err;
  }
  return data;
}

